<template>

  <div id="scroll-board">
      <dv-scroll-board :config="config"/>
  </div>

</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'ScwlOrderScrollBoard',
    computed: {
      ...mapState('bigScreenData', ['orderList'])
    },
    watch: {
      orderList (val, old) {
        let data = []
        for (let li of val) {
          let item = [li.clientName, li.addr, li.concatName + li.concatPhone]
          data.push(item)
        }
        this.config = {
          header: ['订单货主', '收货地址', '收货人'],
          data: data,
          // index: true,
          columnWidth: [160, 160, 180],
          align: ['left'],
          rowNum: 5,
          headerBGC: 'rgba(5,22,65,0.76)',
          headerHeight: 30,
          oddRowBGC: 'rgba(0, 44, 81, 0.8)',
          evenRowBGC: 'rgba(10, 29, 50, 0.8)'
        }
      },
    },
    data () {
      return {
        config: {
          header: ['订单货主', '收货地址', '收货人'],
          data: [],
          // index: true,
          columnWidth: [180, 180],
          align: ['left'],
          rowNum: 5,
          headerBGC: 'rgba(5,22,65,0.76)',
          headerHeight: 30,
          oddRowBGC: 'rgba(0, 44, 81, 0.8)',
          evenRowBGC: 'rgba(10, 29, 50, 0.8)'
        }
      }
    }
  }
</script>

<style lang="less">
  #scroll-board {
    width: 99%;
    box-sizing: border-box;
    margin-left: 20px;
    height: 96%;
    overflow: hidden;
  }
</style>
